import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.documentElement.dataset.theme = "dark";

// The stylesheets size the shell with 100dvh, which the browser interpolates as
// its toolbar collapses. A JS pixel height could only ever lag that and snap
// when it caught up, which is what made the tab bar jump. Only the display mode
// is published here, because the stylesheets key off it.
const setDisplayMode = () => {
  const isStandalone =
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true;
  document.documentElement.dataset.displayMode = isStandalone
    ? "standalone"
    : "browser";
};

setDisplayMode();
window.matchMedia?.("(display-mode: standalone)").addEventListener?.(
  "change",
  setDisplayMode,
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const workerUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker.register(workerUrl).catch(() => {
      // PWA support should never block the trading UI.
    });
  });
}
